import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const DownloadIcon = (properties: iconType) => {
  const { fill } = properties;
  return (
    <>
      <SvgIcon
        {...properties}
        viewBox="0 0 16 20"
        style={{ fill: fill || '#969696', width: '16px', height: '20px' }}
      >
        <path d="M6.16602 6.66675H8.83268V12.381H6.16602V6.66675Z" />
        <path d="M7.49935 16.6667L10.8327 10.9525H4.16602L7.49935 16.6667Z" />
        <path d="M1.58333 20H14.25C15.1208 20 15.8333 19.2742 15.8333 18.3871V7.95161C15.8333 7.51613 15.675 7.1129 15.3742 6.80645L9.15167 0.467742C8.85083 0.16129 8.455 0 8.0275 0H1.58333C0.7125 0 0 0.725806 0 1.6129V18.3871C0 19.2742 0.7125 20 1.58333 20ZM0.632487 1.61309C0.632487 1.08083 1.05999 0.645345 1.58249 0.645345H8.02665C8.27999 0.645345 8.51749 0.742119 8.69165 0.935668L14.9142 7.27438C15.1042 7.4518 15.1992 7.69373 15.1992 7.9518V18.3873C15.1992 18.9195 14.7717 19.355 14.2492 19.355H1.58249C1.05999 19.355 0.632487 18.9195 0.632487 18.3873V1.61309Z" />
      </SvgIcon>
    </>
  );
};

DownloadIcon.defaultProperties = {
  fill: '#969696',
};

export default DownloadIcon;
